import { SOCIAL_LINKS } from './social';
import { SITE_URL } from '../seo/siteConfig';

/** Single source of truth for the QR digital business card at /card */
export const CARD_PROFILE = {
  firstName: 'Andrea',
  lastName: 'Fagioli',
  fullName: 'Andrea Fagioli',
  title: 'Creative Director & Designer',
  headline: 'Landing Pages · Digital Marketing · Brand Design',
  email: 'andrea_fagioli@live.it',
  phone: '+39 3444197875',
  phoneTel: '+393444197875',
  website: SITE_URL,
  websiteLabel: 'andreafagioli.com',
  location: 'Europe & UAE · remote',
  coverage: 'Europe & UAE · open to select projects worldwide',
  servicesNote:
    'Premium landing pages, digital marketing and bespoke websites. Brand identity, motion and hand-crafted design from concept to launch.',
  status: 'Open for select collaborations',
  avatarSrc: '/logo-af.png',
  avatarAlt: 'Andrea Fagioli',
  bio: [
    'Independent creative director since 2019. I design and build premium landing pages, digital marketing funnels and brand-led websites for agencies, studios and companies.',
    'From campaign concept to live channels: strategy, design, motion and code in one workflow. Europe, UAE and select projects beyond.',
  ],
  disciplines: [
    {
      label: 'Web & Landing Page Development',
      detail: 'Custom sites, landing pages and hand-coded responsive builds.',
    },
    {
      label: 'Digital Marketing',
      detail: 'Paid media, funnel strategy and performance across Meta and Google Ads.',
    },
    {
      label: 'Brand & Graphic Design',
      detail: 'Visual identity, campaign assets and editorial design systems.',
    },
    {
      label: 'Creative Direction & AI',
      detail: 'Campaign vision, art direction and hybrid AI production.',
    },
    {
      label: '3D & Visual Production',
      detail: 'Environments, product visualization and cinematic lookdev.',
    },
  ],
  socials: SOCIAL_LINKS,
};
